import { types, flow } from 'mobx-state-tree';
import Player from '../teamsStore/Player';
import API from '../../api/teams';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';

const OutOfLeagyePlayersStore = types
    .model('OutOfLeagyePlayersStore', {
        players: types.optional(types.array(Player), []),
        selectedPlayer: types.maybe(types.reference(Player)),
        error: types.union(
            types.optional(types.string, ''),
            types.optional(types.array(types.string), []),
        ),
        isLoading: types.optional(types.boolean, false),
        dataLoaded: types.optional(types.boolean, false),
    })
    .actions((self) => ({
        selectPlayer(id) {
            self.selectedPlayer = id;
        },
        getPlayers: flow(function* getPlayers() {
            self.error = '';
            try {
                const playersData = yield API.getOutOfLeaguePlayers();
                const players = playersData.data.map((player) => ({
                    ...player,
                    team_id: 'null',
                }));
                self.players = players;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        getPlayer: flow(function* getPlayer(player_id) {
            self.error = '';
            try {
                if (self.players.length === 0) {
                    const playersData = yield API.getOutOfLeaguePlayers();
                    const players = playersData.data.map((player) => ({
                        ...player,
                        team_id: 'null',
                    }));
                    self.players = players;
                }
                const player = yield API.getPlayer(player_id);
                self.dataLoaded = true;

                self.selectedPlayer = player.data.id;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        editPlayer: flow(function* editPlayer(edited) {
            try {
                const res = yield API.editPlayer(self.selectedPlayer.id, edited);
                self.selectedPlayer.editPlayer(res.data);
            } catch (error) {
                throw error;
            }
        }),
        deletePlayer: flow(function* deletePlayer(playerId) {
            try {
                yield API.deletePlayer(playerId);
                self.players.replace(self.players.filter((p) => p.id !== playerId));
                if (self.selectedPlayer === playerId) {
                    self.selectedPlayer = null;
                }
            } catch (error) {
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        setDataLoaded() {
            self.dataLoaded = true;
        },
    }));

export default OutOfLeagyePlayersStore;
